<template>
    <div id="tipSuccess" aria-hidden="true"
         class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body text-center">
                    <div class="tip-icon-container">
                        <CoinSolidComponent width="48px" height="48px" color="#E7407C"/>
                    </div>

                    <h5 class="galleryTitle">{{ translate.account.tips.successTitle }}</h5>
                    <p class="tip-confirm-description">{{ successText }}</p>

                    <button class="btn btn-rebrand-primary btn-rebrand-sm w-100"
                            @click.prevent="closeModal()">
                        {{ translate.home.close }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoinSolidComponent from "@/components/global/icons/CoinSolidComponent.vue";

const data = () => ({
    amount: 0,
    username: '',
})

function initModal(username, amount) {
    this.username = username;
    this.amount = amount;
    setTimeout(() => {
        $(() => {
            const element = $('#tipSuccess');
            if (element && typeof element.modal === 'function') {
                element.modal('show');
            }
        });
    });
}

function closeModal() {
    $('#tipSuccess').modal('hide');
}

export default {
    data,
    computed: {
        ...mapState(['translate']),
        successText() {
            return this.translate.account.tips.youHaveSuccessfullyTippedText
                .replace(':username', this.username)
                .replace(':amount', this.amount);
        },
    },
    methods: {
        initModal,
        closeModal,
    },
    components: {
        CoinSolidComponent,
    },
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
